import React, { Fragment, Component } from "react";
import {
  Div,
  Popover,
  MediumOutlineButton,
  RightArrowIcon,
  modalHandler,
  Modal,
  SmallOutlineBox
} from "components/Base";
import RelatedModuleTableBuilder from "components/Global/CRM/MergeTags/GenerateTable";
import * as R from "ramda";

const MenuItem = ({ children, isTable, isSummary, onClick, ...props }) => (
  <Div
    px={4}
    py={2}
    bg={{ default: "white", hover: "neutral1" }}
    transition="fast"
    width={1}
    onClick={onClick} // tag.tag
    display="row.flex-start.center"
    color="#494949"
    style={{
      fontSize: "14px"
    }}
    {...props}
  >
    {children}
    {isTable && <SmallOutlineBox ml={2}>Table</SmallOutlineBox>}
    {isSummary && <SmallOutlineBox ml={2}>Summary</SmallOutlineBox>}
  </Div>
);

const TableMenuItem = modalHandler()(
  ({
    showModal,
    closeModal,
    tag,
    fields,
    isModalShowing,
    onClick,
    children
  }) => [
    <MenuItem isTable onClick={showModal}>
      {children}
    </MenuItem>,
    <Modal isPortal background="translucent" isModalShowing={isModalShowing}>
      <RelatedModuleTableBuilder
        fields={fields}
        moduleName={tag}
        hideModal={closeModal}
        onSave={derivedTag => {
          closeModal();
          onClick(derivedTag);
        }}
      />
    </Modal>
  ]
);

const formatTag = tag => `{{{${tag}}}}`;

class MergeTagMenu extends Component {
  render() {
    let { onMergeTagSelect, mergeTags } = this.props;

    if (!mergeTags || !mergeTags.length) {
      return null;
    }

    mergeTags = R.map(({ fields, ...t }) => ({
      ...t,
      primary: R.filter(
        f =>
          f.is_primary_field &&
          f.meta.type !== "summary" &&
          f.meta.type !== "form" &&
          f.meta.type !== "portal_login_link" &&
          f.meta.type !== "application_forms" &&
          f.meta.type !== "session_submission_forms"
      )(fields),
      summary: R.filter(f => f.meta.type === "summary")(fields),
      forms: R.filter(f => f.meta.type === "form")(fields),
      sessionSubmissionForms: R.filter(
        f => f.meta.type === "session_submission_forms"
      )(fields),
      portalLoginLinks: R.filter(f => f.meta.type === "portal_login_link")(
        fields
      ),
      applicationForms: R.filter(f => f.meta.type === "application_forms")(
        fields
      ),
      secondary: R.filter(
        f =>
          !f.is_primary_field &&
          f.meta.type !== "summary" &&
          f.meta.type !== "form" &&
          f.meta.type !== "portal_login_link" &&
          f.meta.type !== "application_forms" &&
          f.meta.type !== "session_submission_forms"
      )(fields)
    }))(mergeTags);

    return (
      <Popover
        Label={({ onClick }) => (
          <MediumOutlineButton type="button" onClick={onClick}>
            Merge Tags
          </MediumOutlineButton>
        )}
      >
        {({ closePopover }) => (
          <Div width={250} display="column.flex-start.flex-start">
            {mergeTags.map(
              (
                {
                  name,
                  primary,
                  summary,
                  forms,
                  sessionSubmissionForms,
                  applicationForms,
                  portalLoginLinks,
                  secondary
                },
                idx
              ) => {
                return (
                  <Fragment>
                    <Div
                      fw={3}
                      style={{
                        borderTop: idx !== 0 ? "1px solid #E7E6EA" : undefined,
                        width: "100%",
                        textTransform: "uppercase",
                        fontSize: "12px",
                        color: "#868686",
                        marginTop: idx !== 0 ? "5px" : undefined,
                        padding: "14px 12px 7px 12px"
                      }}
                    >
                      {name}
                    </Div>
                    {(primary.length ? primary : secondary).map(tag => {
                      if ("fields" in tag) {
                        return (
                          <TableMenuItem
                            key={tag.field_id}
                            onClick={derivedTag => {
                              closePopover();
                              onMergeTagSelect(derivedTag);
                            }}
                            fields={tag.fields}
                            tag={tag.tag}
                          >
                            {tag.name}
                          </TableMenuItem>
                        );
                      }
                      return (
                        <MenuItem
                          key={tag.field_id}
                          onClick={() => {
                            closePopover();
                            onMergeTagSelect(formatTag(tag.tag));
                          }}
                        >
                          {tag.name}
                        </MenuItem>
                      );
                    })}

                    {forms.length > 0 ? (
                      <Popover
                        wrapperProps={{
                          width: 1,
                          display: "row.flex-start.center"
                        }}
                        innerSpanStyle={{ flex: 1 }}
                        anchorOrigin={{ horizontal: "right", vertical: "top" }}
                        transformOrigin={{
                          horizontal: "left",
                          vertical: "top"
                        }}
                        Label={({ onClick }) => (
                          <MenuItem
                            onClick={onClick}
                            display="row.flex-start.center"
                            flex={1}
                          >
                            <span>Forms</span>
                            <RightArrowIcon ml={2} sizeWFS={3} />
                          </MenuItem>
                        )}
                      >
                        {props => (
                          <Div
                            width={250}
                            display="column.flex-start.flex-start"
                          >
                            {forms.map(tag => {
                              return (
                                <MenuItem
                                  key={tag.field_id}
                                  onClick={() => {
                                    props.closePopover();
                                    closePopover();
                                    onMergeTagSelect(formatTag(tag.tag));
                                  }}
                                >
                                  {tag.name}
                                </MenuItem>
                              );
                            })}
                          </Div>
                        )}
                      </Popover>
                    ) : null}

                    {portalLoginLinks.length === 1 &&
                      portalLoginLinks.map(tag => {
                        if ("fields" in tag) {
                          return (
                            <TableMenuItem
                              key={tag.field_id}
                              onClick={derivedTag => {
                                closePopover();
                                onMergeTagSelect(derivedTag);
                              }}
                              fields={tag.fields}
                              tag={tag.tag}
                            >
                              {tag.name}
                            </TableMenuItem>
                          );
                        }
                        return (
                          <MenuItem
                            key={tag.field_id}
                            onClick={() => {
                              closePopover();
                              onMergeTagSelect(formatTag(tag.tag));
                            }}
                          >
                            {tag.name}
                          </MenuItem>
                        );
                      })}
                    {portalLoginLinks.length > 1 ? (
                      <Popover
                        wrapperProps={{
                          width: 1,
                          display: "row.flex-start.center"
                        }}
                        innerSpanStyle={{ flex: 1 }}
                        anchorOrigin={{ horizontal: "right", vertical: "top" }}
                        transformOrigin={{
                          horizontal: "left",
                          vertical: "top"
                        }}
                        Label={({ onClick }) => (
                          <MenuItem
                            onClick={onClick}
                            display="row.flex-start.center"
                            flex={1}
                          >
                            <span>Portal Login Links</span>
                            <RightArrowIcon ml={2} sizeWFS={3} />
                          </MenuItem>
                        )}
                      >
                        {props => (
                          <Div
                            width={250}
                            display="column.flex-start.flex-start"
                          >
                            {portalLoginLinks.map(tag => {
                              return (
                                <MenuItem
                                  key={tag.tag}
                                  onClick={() => {
                                    props.closePopover();
                                    closePopover();
                                    onMergeTagSelect(formatTag(tag.tag));
                                  }}
                                >
                                  {tag.name}
                                </MenuItem>
                              );
                            })}
                          </Div>
                        )}
                      </Popover>
                    ) : null}
                    {sessionSubmissionForms.length > 0 ? (
                      <Popover
                        wrapperProps={{
                          width: 1,
                          display: "row.flex-start.center"
                        }}
                        innerSpanStyle={{ flex: 1 }}
                        anchorOrigin={{ horizontal: "right", vertical: "top" }}
                        transformOrigin={{
                          horizontal: "left",
                          vertical: "top"
                        }}
                        Label={({ onClick }) => (
                          <MenuItem
                            onClick={onClick}
                            display="row.flex-start.center"
                            flex={1}
                          >
                            <span>Session Submission Forms</span>
                            <RightArrowIcon ml={2} sizeWFS={3} />
                          </MenuItem>
                        )}
                      >
                        {props => (
                          <Div
                            width={250}
                            display="column.flex-start.flex-start"
                          >
                            {sessionSubmissionForms.map(tag => {
                              return (
                                <MenuItem
                                  key={tag.tag}
                                  onClick={() => {
                                    props.closePopover();
                                    closePopover();
                                    onMergeTagSelect(formatTag(tag.tag));
                                  }}
                                >
                                  {tag.name}
                                </MenuItem>
                              );
                            })}
                          </Div>
                        )}
                      </Popover>
                    ) : null}
                    {applicationForms.length > 0 ? (
                      <Popover
                        wrapperProps={{
                          width: 1,
                          display: "row.flex-start.center"
                        }}
                        innerSpanStyle={{ flex: 1 }}
                        anchorOrigin={{ horizontal: "right", vertical: "top" }}
                        transformOrigin={{
                          horizontal: "left",
                          vertical: "top"
                        }}
                        Label={({ onClick }) => (
                          <MenuItem
                            onClick={onClick}
                            display="row.flex-start.center"
                            flex={1}
                          >
                            <span>Application forms</span>
                            <RightArrowIcon ml={2} sizeWFS={3} />
                          </MenuItem>
                        )}
                      >
                        {props => (
                          <Div
                            width={250}
                            display="column.flex-start.flex-start"
                          >
                            {applicationForms.map(tag => {
                              return (
                                <MenuItem
                                  key={tag.tag}
                                  onClick={() => {
                                    props.closePopover();
                                    closePopover();
                                    onMergeTagSelect(formatTag(tag.tag));
                                  }}
                                >
                                  {tag.name}
                                </MenuItem>
                              );
                            })}
                          </Div>
                        )}
                      </Popover>
                    ) : null}

                    {summary.length > 0 ? (
                      <Popover
                        wrapperProps={{
                          width: 1,
                          display: "row.flex-start.center"
                        }}
                        innerSpanStyle={{ flex: 1 }}
                        anchorOrigin={{ horizontal: "right", vertical: "top" }}
                        transformOrigin={{
                          horizontal: "left",
                          vertical: "top"
                        }}
                        Label={({ onClick }) => (
                          <MenuItem
                            onClick={onClick}
                            display="row.flex-start.center"
                            flex={1}
                          >
                            <span>Summary</span>
                            <RightArrowIcon ml={2} sizeWFS={3} />
                          </MenuItem>
                        )}
                      >
                        {props => (
                          <Div
                            width={250}
                            display="column.flex-start.flex-start"
                          >
                            {summary.map(tag => {
                              return (
                                <MenuItem
                                  key={tag.field_id}
                                  onClick={() => {
                                    props.closePopover();
                                    closePopover();
                                    onMergeTagSelect(formatTag(tag.tag));
                                  }}
                                >
                                  {tag.name}
                                </MenuItem>
                              );
                            })}
                          </Div>
                        )}
                      </Popover>
                    ) : null}

                    {primary.length > 0 && secondary.length > 0 ? (
                      <Popover
                        wrapperProps={{
                          width: 1,
                          display: "row.flex-start.center"
                        }}
                        innerSpanStyle={{ flex: 1 }}
                        anchorOrigin={{ horizontal: "right", vertical: "top" }}
                        transformOrigin={{
                          horizontal: "left",
                          vertical: "top"
                        }}
                        Label={({ onClick }) => (
                          <MenuItem
                            onClick={onClick}
                            display="row.flex-start.center"
                            flex={1}
                          >
                            <span>More</span>
                            <RightArrowIcon ml={2} sizeWFS={3} />
                          </MenuItem>
                        )}
                      >
                        {props => (
                          <Div
                            width={250}
                            display="column.flex-start.flex-start"
                          >
                            {secondary.map(tag => {
                              if ("fields" in tag) {
                                return (
                                  <TableMenuItem
                                    key={tag.field_id}
                                    onClick={derivedTag => {
                                      props.closePopover();
                                      closePopover();
                                      onMergeTagSelect(derivedTag);
                                    }}
                                    fields={tag.fields}
                                    tag={tag.tag}
                                  >
                                    {tag.name}
                                  </TableMenuItem>
                                );
                              }
                              return (
                                <MenuItem
                                  key={tag.field_id}
                                  onClick={() => {
                                    props.closePopover();
                                    closePopover();
                                    onMergeTagSelect(formatTag(tag.tag));
                                  }}
                                >
                                  {tag.name}
                                </MenuItem>
                              );
                            })}
                          </Div>
                        )}
                      </Popover>
                    ) : (
                      ""
                    )}
                  </Fragment>
                );
              }
            )}
          </Div>
        )}
      </Popover>
    );
  }
}

MergeTagMenu.propTypes = {};

export default modalHandler()(MergeTagMenu);
